import { TreeView, type TreeViewProps } from '@mui/x-tree-view/TreeView'
import React from 'react'

import theme from 'theme'

export const ConcurrentTree: React.FC<TreeViewProps> = ({
  expanded = [],
  // defaultExpanded = [], // TODO
  children,
  ...rest
}) => {
  // TODO for managing the state of the tree nodes so we can control branch icon sub-glyphs
  // const [expanded, setExpanded] = React.useState<string[]>(defaultExpanded)
  return (
    <TreeView
      disableSelection
      aria-label="customized"
      // TODO disabling expand/collapse for now as it causes problems when adding new graph nodes
      // TODO we have to revisit this later
      // defaultExpanded={defaultExpanded}
      // expanded={{}}
      // onNodeToggle={() => null} // TODO manage state
      expanded={expanded.length > 0 ? expanded : undefined}
      sx={{
        width: 'fit-content', // maintain thinner width, but also don't force content to wrap
        '& .MuiTreeItem-iconContainer': {
          margin: `${theme.space[1]}px`,
          width: 'fit-content !important' // being overridden to 15px in MuiTreeItem-content
        }
      }}
      {...rest}
    >
      {children}
    </TreeView>
  )
}
